import request, { REQUEST_METHODS } from '@api/Request';
import { UserRoleCapabilityEndpoints } from './config';
import type { GetUserRoleCapabilitiesResponse } from './types';

export default class UserRoleCapabilitiesService {
  public static readonly getUserRoleCapabilities = (): Promise<GetUserRoleCapabilitiesResponse> =>
    request({
      url: UserRoleCapabilityEndpoints.getUserRoleCapabilities(),
      method: REQUEST_METHODS.GET,
    });
}
